(function initStickyNav() {
    const nav = document.querySelector('.sticky-nav');
    if (!nav) return;

    const defaultThreshold = parseInt(nav.dataset.threshold || '100', 10) || 100;
    const triggerSelector = nav.dataset.triggerSelector;
    const scroller = nav.querySelector('.sticky-nav__items');
    const items = Array.from(nav.querySelectorAll('.sticky-nav__item[data-target]'));
    const navContext = nav.dataset.context || 'product_detail';
    const manualVariantId = nav.dataset.manualVariantId;
    const variantIdSelector = nav.dataset.variantIdSelector;
    const quantitySelector = nav.dataset.quantitySelector;
    const moneyFormat =
      nav.dataset.moneyFormat ||
      (window.theme && window.theme.settings && window.theme.settings.money_with_currency_format);
    const showCompareAt = nav.dataset.showCompareAt === 'true';
    const rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    const cartAddUrl = `${rootUrl.replace(/\/$/, '')}/cart/add.js`;
    const priceWrap = nav.querySelector('.sticky-nav__price');
    const priceEl = nav.querySelector('[data-sticky-nav-price]');
    const comparePriceEl = nav.querySelector('[data-sticky-nav-compare-price]');
    const actionButtons = Array.from(nav.querySelectorAll('[data-sticky-nav-action]'));
    const variantsJson = document.querySelector('[data-sticky-nav-variants]');
    let variants = variantsJson ? JSON.parse(variantsJson.textContent || '[]') : [];
    let activeItem = null;
    let currentVariant = null;
    let trackedVariantId = null;

    const formatPrice = (price) => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(price, moneyFormat);

      return (price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      });
    };

    const findVariantById = (variantId) => {
      if (!variantId) return null;
      return variants.find((variant) => String(variant.id) === String(variantId)) || null;
    };

    const getPageVariants = () => {
      const variantDataScripts = Array.from(
        document.querySelectorAll('variant-selects [type="application/json"], variant-radios [type="application/json"]')
      );

      return variantDataScripts.reduce((pageVariants, script) => {
        try {
          const parsedVariants = JSON.parse(script.textContent || '[]');
          if (Array.isArray(parsedVariants)) {
            pageVariants.push(...parsedVariants);
          }
        } catch (error) {
          // Ignore malformed variant JSON from unrelated widgets.
        }

        return pageVariants;
      }, []);
    };

    const refreshPageVariants = () => {
      if (navContext !== 'purchase_page') return;

      const pageVariants = getPageVariants();
      if (pageVariants.length) {
        variants = pageVariants;
      }
    };

    const getVariantFromPicker = () => {
      const pickers = Array.from(document.querySelectorAll('variant-selects, variant-radios'));
      const pickerWithVariant = pickers.find((picker) => picker.currentVariant && picker.currentVariant.id);

      return pickerWithVariant ? pickerWithVariant.currentVariant : null;
    };

    const getVariantIdFromSelector = () => {
      const selector = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
      const input = document.querySelector(selector);
      if (!input) return null;

      return input.value || input.getAttribute('value') || input.dataset.variantId || null;
    };

    const getQuantity = () => {
      const selector = quantitySelector || 'form[action*="/cart/add"] [name="quantity"]';
      const input = document.querySelector(selector);
      const quantity = input ? parseInt(input.value, 10) : 1;

      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const setActionButtonsDisabled = (disabled) => {
      actionButtons.forEach((button) => {
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
    };

    const sectionsToRender = [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer',
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count',
      },
    ];

    const getSectionInnerHTML = (html, selector) => {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    };

    const renderCartSections = (state) => {
      if (!state.sections) return;

      sectionsToRender.forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container || !state.sections[section.section]) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        elementToReplace.innerHTML = getSectionInnerHTML(state.sections[section.section], section.selector);
      });

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.removeProductEvent?.();
        cartDrawer.open?.();
      }
    };

    const showButtonSuccess = (button) => {
      if (!button || button.dataset.successTimer) return;

      const originalHtml = button.innerHTML;
      const originalWidth = button.getBoundingClientRect().width;
      button.style.width = `${originalWidth}px`;
      button.innerHTML =
        '<svg class="sticky-nav__btn-success-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M13.5 4.5 6.8 11.2 2.5 6.9" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const timer = window.setTimeout(() => {
        button.innerHTML = originalHtml;
        button.style.width = '';
        delete button.dataset.successTimer;
      }, 3000);

      button.dataset.successTimer = String(timer);
    };

    const updatePrice = (variant) => {
      if (!priceWrap || !priceEl) return;

      if (!variant || typeof variant.price !== 'number') {
        priceWrap.classList.add('hidden');
        setActionButtonsDisabled(!variant || !variant.id);
        return;
      }

      priceWrap.classList.remove('hidden');
      priceEl.innerHTML = formatPrice(variant.price);
      priceWrap.setAttribute('aria-label', priceEl.textContent);

      if (comparePriceEl) {
        const compareAtPrice = variant.compare_at_price || variant.compare_at_price_max || 0;
        if (showCompareAt && compareAtPrice > variant.price) {
          comparePriceEl.innerHTML = formatPrice(compareAtPrice);
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.innerHTML = '';
          comparePriceEl.classList.add('hidden');
        }
      }

      setActionButtonsDisabled(false);
    };

    const setCurrentVariant = (variant) => {
      currentVariant = variant || null;
      updatePrice(currentVariant);
    };

    const resolveCurrentVariant = () => {
      if (navContext === 'product_detail') return currentVariant || findVariantById(manualVariantId);

      if (trackedVariantId) {
        refreshPageVariants();
        const tracked = findVariantById(trackedVariantId);
        if (tracked) return tracked;
      }

      const pickerVariant = getVariantFromPicker();
      if (pickerVariant && typeof pickerVariant.price === 'number') return pickerVariant;

      refreshPageVariants();
      const variantId = getVariantIdFromSelector();
      const matchedVariant = findVariantById(variantId);
      if (matchedVariant) return matchedVariant;

      return currentVariant || (variantId ? { id: variantId } : null);
    };

    const syncCurrentVariant = () => {
      setCurrentVariant(resolveCurrentVariant());
    };

    syncCurrentVariant();

    if (navContext === 'purchase_page') {
      if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', syncCurrentVariant, { once: true });
      } else {
        syncCurrentVariant();
      }

      window.addEventListener('load', syncCurrentVariant, { once: true });
      window.setTimeout(syncCurrentVariant, 100);
      window.setTimeout(syncCurrentVariant, 500);

      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('variant-selects').then(() => {
          requestAnimationFrame(syncCurrentVariant);
        });
      }
    }

    document.addEventListener('product:variant-change', (event) => {
      if (navContext !== 'purchase_page') return;
      setCurrentVariant(event.detail && event.detail.variant ? event.detail.variant : resolveCurrentVariant());
    });

    document.addEventListener('change', (event) => {
      if (navContext !== 'purchase_page') return;
      const selector = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
      if (!event.target.matches(selector)) return;
      setCurrentVariant(resolveCurrentVariant());
    });

    actionButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const variant = resolveCurrentVariant();
        const variantId = variant && variant.id ? parseInt(variant.id, 10) : NaN;
        if (!Number.isFinite(variantId)) {
          setActionButtonsDisabled(true);
          return;
        }

        const quantity = getQuantity();
        const formData = {
          items: [{ id: variantId, quantity }],
          sections: sectionsToRender.map((section) => section.section),
          sections_url: window.location.pathname,
        };

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.warn('Sticky nav cart add failed:', errorText);
          return;
        }
        const cartData = await response.json();
        renderCartSections(cartData);
        showButtonSuccess(button);

        const addedProduct = cartData.items ? cartData.items[0] : cartData;

        document.dispatchEvent(
          new CustomEvent('cart:item-added', {
            detail: {
              product: addedProduct,
            },
          })
        );

        // Push GA4 add_to_cart event for sticky nav
        (function pushStickyNavAddToCart() {
          if (!addedProduct) return;

          // 解析价格（Shopify API 返回的价格单位是分）
          const itemFinalPrice = (addedProduct.final_price || addedProduct.price || 0) / 100;
          const itemComparePrice = addedProduct.compare_at_price
            ? addedProduct.compare_at_price / 100
            : itemFinalPrice;

          const quantity = addedProduct.quantity || 1;
          const discountAmount = itemComparePrice > itemFinalPrice
            ? parseFloat((itemComparePrice - itemFinalPrice).toFixed(2))
            : 0;

          // 获取变体名称
          const variantName = addedProduct.variant_title ||
            (addedProduct.options_with_values
              ? addedProduct.options_with_values.map(opt => opt.value).join(' / ')
              : '');

          // 获取按钮文本
          const buttonText = button.innerText.trim() || 'Add to Cart';

          // 推送到 dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ "event_parameters": null });
          window.dataLayer.push({
            "event": "ga4Event",
            "event_name": "add_to_cart",
            "event_parameters": {
              "currency": (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
              "value": parseFloat((itemFinalPrice * quantity).toFixed(2)),
              "button_name": buttonText,
              "module_name": "sticky_nav",
              "items": [{
                "item_id": String(addedProduct.variant_id || addedProduct.id),
                "item_name": addedProduct.product_title || addedProduct.title,
                "discount": discountAmount,
                "coupon": "",
                "index": 1,
                "item_variant": variantName,
                "item_brand": "Speediance",
                "price": itemFinalPrice,
                "quantity": quantity,
                "item_category": addedProduct.product_type || ""
              }]
            }
          });

          // 触发购物车抽屉浏览事件（如果存在）
          if (typeof reportCartDrawerView === 'function') {
            setTimeout(reportCartDrawerView, 300);
          }
        })();

      });
    });

    const getStickyThreshold = () => {
      if (!triggerSelector) return defaultThreshold;

      const trigger = document.querySelector(triggerSelector);
      if (!trigger) return defaultThreshold;

      return trigger.getBoundingClientRect().top + window.scrollY;
    };

    const updateSticky = () => {
      const isSticky = window.scrollY >= getStickyThreshold();
      nav.classList.toggle('is-sticky', isSticky);
      if (!isSticky) {
        const dropdown = document.querySelector('.sticky-nav__variant-dropdown');
        const trigger = nav.querySelector('.sticky-nav__variant-trigger');
        if (dropdown && !dropdown.hidden) {
          dropdown.hidden = true;
          trigger && trigger.setAttribute('aria-expanded', 'false');
        }
      }
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();

    const getItemFromEvent = (event) => {
      const target =
        event.target && event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;

      return target && target.closest ? target.closest('.sticky-nav__item[data-target]') : null;
    };

    const scrollToItemTarget = (item) => {
      if (!item) return;

      const target = document.querySelector(item.dataset.target);
      if (!target) return;

      scrollActiveItemIntoView(item);
      const top = target.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - 8;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    items.forEach((item) => {
      item.addEventListener('click', () => {
        scrollToItemTarget(item);
      });
    });

    const updateScrollerState = () => {
      if (!scroller) return;
      scroller.classList.toggle('is-scrollable', scroller.scrollWidth > scroller.clientWidth + 1);
    };

    const initNativeDragScroll = () => {
      if (!scroller || scroller.dataset.dragScrollReady === 'true') return;
      scroller.dataset.dragScrollReady = 'true';

      let pointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let hasMoved = false;
      let suppressClick = false;
      let pressedItem = null;

      scroller.addEventListener('pointerdown', (event) => {
        if (scroller.scrollWidth <= scroller.clientWidth || event.button > 0) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        hasMoved = false;
        pressedItem = getItemFromEvent(event);
        scroller.setPointerCapture(pointerId);
      });

      scroller.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 4) {
          hasMoved = true;
          scroller.classList.add('is-dragging');
          event.preventDefault();
        }

        scroller.scrollLeft = startScrollLeft - deltaX;
      });

      const endDrag = (event) => {
        if (pointerId !== event.pointerId) return;

        pointerId = null;
        scroller.classList.remove('is-dragging');

        if (!hasMoved && pressedItem) {
          scrollToItemTarget(pressedItem);
          suppressClick = true;
        } else if (hasMoved) {
          suppressClick = true;
        }

        pressedItem = null;
        window.setTimeout(() => {
          suppressClick = false;
        }, 120);
      };

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('lostpointercapture', () => {
        pointerId = null;
        pressedItem = null;
        scroller.classList.remove('is-dragging');
      });

      scroller.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;

          event.preventDefault();
          event.stopImmediatePropagation();
        },
        true
      );
    };

    const initDragScroll = () => {
      updateScrollerState();
      initNativeDragScroll();
    };

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', initDragScroll, { once: true });
    } else {
      initDragScroll();
    }

    window.addEventListener('resize', updateScrollerState);

    const scrollActiveItemIntoView = (item) => {
      if (!scroller || !item || scroller.scrollWidth <= scroller.clientWidth) return;

      const itemLeft = item.offsetLeft;
      const itemRight = itemLeft + item.offsetWidth;
      const viewLeft = scroller.scrollLeft;
      const viewRight = viewLeft + scroller.clientWidth;
      const edgePadding = 16;

      if (itemLeft < viewLeft + edgePadding) {
        scroller.scrollTo({
          left: Math.max(itemLeft - edgePadding, 0),
          behavior: 'smooth',
        });
      } else if (itemRight > viewRight - edgePadding) {
        scroller.scrollTo({
          left: itemRight - scroller.clientWidth + edgePadding,
          behavior: 'smooth',
        });
      }
    };

    const updateActive = () => {
      const offset = window.scrollY + nav.offsetHeight + 40;
      let active = null;
      items.forEach((item) => {
        const el = document.querySelector(item.dataset.target);
        if (!el) return;
        if (el.getBoundingClientRect().top + window.scrollY <= offset) active = item;
      });
      items.forEach((item) => item.classList.toggle('is-active', item === active));
      if (active !== activeItem) {
        activeItem = active;
        scrollActiveItemIntoView(activeItem);
      }
    };

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();

    // Variant picker dropdown
    const showVariantPicker = nav.dataset.showVariantPicker === 'true';
    const variantTrigger = nav.querySelector('.sticky-nav__variant-trigger');
    const variantDropdown = document.querySelector('.sticky-nav__variant-dropdown');
    const variantList = document.querySelector('[data-sticky-nav-variant-list]');
    const variantLabelEl = nav.querySelector('[data-sticky-nav-variant-label]');

    if (showVariantPicker && variantTrigger && variantDropdown) {
      let optionNames = [];
      try { optionNames = JSON.parse(nav.dataset.optionNames || '[]'); } catch (e) {}

      const getPageVariantsFull = () => {
        if (navContext === 'product_detail') return variants;
        const scripts = Array.from(document.querySelectorAll(
          'variant-selects [type="application/json"], variant-radios [type="application/json"]'
        ));
        for (const s of scripts) {
          try {
            const parsed = JSON.parse(s.textContent || '[]');
            if (Array.isArray(parsed) && parsed.length) return parsed;
          } catch (e) {}
        }
        return [];
      };

      const getCurrentVariantId = () => {
        if (trackedVariantId) return String(trackedVariantId);
        if (navContext === 'product_detail') {
          return currentVariant && currentVariant.id ? String(currentVariant.id) : '';
        }
        const picker = Array.from(document.querySelectorAll('variant-selects, variant-radios'))
          .find((p) => p.currentVariant && p.currentVariant.id);
        if (picker) return String(picker.currentVariant.id);
        const sel = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
        const input = document.querySelector(sel);
        return input ? String(input.value || input.dataset.variantId || '') : '';
      };

      const updateVariantLabel = (variantId) => {
        if (!variantLabelEl) return;
        const allVariants = getPageVariantsFull();
        const v = allVariants.find((vv) => String(vv.id) === String(variantId));
        variantLabelEl.textContent = v ? v.title : '';
      };

      const renderDropdown = () => {
        const allVariants = getPageVariantsFull();
        if (!allVariants.length) return;
        const currentId = getCurrentVariantId();
        const currentVariant = allVariants.find((v) => String(v.id) === currentId);
        const currentOptions = currentVariant ? currentVariant.options : [];

        if (optionNames.length > 1) {
          variantList.innerHTML = optionNames.map((optionName, optIdx) => {
            const uniqueValues = [];
            allVariants.forEach((v) => {
              const val = v.options[optIdx];
              if (val && !uniqueValues.includes(val)) uniqueValues.push(val);
            });
            const selectedVal = currentOptions[optIdx] || '';

            const optButtons = uniqueValues.map((val) => {
              const isSelected = val === selectedVal;
              const hasAvailable = allVariants.some((v) => v.options[optIdx] === val && v.available);
              return `<button
                type="button"
                class="sticky-nav__variant-option${isSelected ? ' is-selected' : ''}${!hasAvailable ? ' is-unavailable' : ''}"
                data-option-index="${optIdx}"
                data-option-value="${val.replace(/"/g, '&quot;')}"
                ${!hasAvailable ? 'disabled' : ''}
              >${val}${isSelected ? '<svg class="sticky-nav__variant-check" viewBox="0 0 16 16" aria-hidden="true"><path d="M13 4L6.5 11 3 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : ''}</button>`;
            }).join('');

            return `<div class="sticky-nav__variant-group">
              <div class="sticky-nav__variant-group-label">${optionName}</div>
              ${optButtons}
            </div>`;
          }).join('');

          variantList.querySelectorAll('.sticky-nav__variant-option[data-option-index]:not([disabled])').forEach((btn) => {
            btn.addEventListener('click', () => {
              const optIdx = parseInt(btn.dataset.optionIndex, 10);
              const optVal = btn.dataset.optionValue;
              const variants = getPageVariantsFull();
              const curId = getCurrentVariantId();
              const curVariant = variants.find((v) => String(v.id) === curId);
              const newOptions = curVariant ? [...curVariant.options] : [];
              newOptions[optIdx] = optVal;
              const matched = variants.find((v) => v.options.every((o, i) => o === newOptions[i]));
              if (matched) {
                selectVariantOnPage(String(matched.id));
                closeDropdown();
              }
            });
          });
        } else {
          variantList.innerHTML = `<div class="sticky-nav__variant-group">${
            allVariants.map((v) => {
              const isSelected = String(v.id) === currentId;
              const unavailable = !v.available;
              return `<button
                type="button"
                class="sticky-nav__variant-option${isSelected ? ' is-selected' : ''}${unavailable ? ' is-unavailable' : ''}"
                data-variant-id="${v.id}"
                ${unavailable ? 'disabled' : ''}
              >${v.title}${isSelected ? '<svg class="sticky-nav__variant-check" viewBox="0 0 16 16" aria-hidden="true"><path d="M13 4L6.5 11 3 7.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' : ''}</button>`;
            }).join('')
          }</div>`;

          variantList.querySelectorAll('.sticky-nav__variant-option[data-variant-id]:not([disabled])').forEach((btn) => {
            btn.addEventListener('click', () => {
              selectVariantOnPage(btn.dataset.variantId);
              closeDropdown();
            });
          });
        }
      };

      const selectVariantOnPage = (variantId) => {
        trackedVariantId = variantId;
        if (navContext === 'product_detail') {
          const allVariants = getPageVariantsFull();
          const v = allVariants.find((vv) => String(vv.id) === String(variantId));
          if (v) setCurrentVariant(v);
          updateVariantLabel(variantId);
          return;
        }

        // purchase_page: sync page variant selectors by clicking radio inputs
        const allVariants = getPageVariantsFull();
        const v = allVariants.find((vv) => String(vv.id) === String(variantId));
        if (v && v.options && optionNames.length) {
          optionNames.forEach((optionName, optIdx) => {
            const optVal = v.options[optIdx];
            if (!optVal) return;
            // radio input: name="options[OptionName]", value=optVal
            const radio = document.querySelector(
              `variant-selects input[type="radio"][name="options[${optionName}]"][value="${CSS.escape(optVal)}"],
               variant-selects input[type="radio"][name="${optionName}"][value="${CSS.escape(optVal)}"]`
            );
            if (radio && !radio.checked) {
              radio.click();
            } else {
              // fallback: select dropdown
              const select = document.querySelector(
                `variant-selects select[name="options[${optionName}]"]`
              );
              if (select && select.value !== optVal) {
                select.value = optVal;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          });
          return;
        }

        // fallback: directly set hidden id input
        const selector = variantIdSelector || 'form[action*="/cart/add"] [name="id"]';
        const input = document.querySelector(selector);
        if (input) {
          const nativeSet = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
          nativeSet.call(input, variantId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (v) {
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        }
        updateVariantLabel(variantId);
      };

      const positionDropdown = () => {
        const rect = variantTrigger.getBoundingClientRect();
        const isBottom = nav.classList.contains('sticky-nav--bottom');
        if (isBottom) {
          variantDropdown.style.bottom = (window.innerHeight - rect.top + 4) + 'px';
          variantDropdown.style.top = 'auto';
        } else {
          variantDropdown.style.top = (rect.bottom + 4) + 'px';
          variantDropdown.style.bottom = 'auto';
        }
        variantDropdown.style.left = rect.left + 'px';
      };

      const openDropdown = () => {
        renderDropdown();
        variantDropdown.hidden = false;
        positionDropdown();
        variantTrigger.setAttribute('aria-expanded', 'true');
      };

      const closeDropdown = () => {
        variantDropdown.hidden = true;
        variantTrigger.setAttribute('aria-expanded', 'false');
      };

      variantTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        variantDropdown.hidden ? openDropdown() : closeDropdown();
      });

      document.addEventListener('click', (e) => {
        if (!variantDropdown.hidden && !nav.contains(e.target)) closeDropdown();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !variantDropdown.hidden) closeDropdown();
      });

      document.addEventListener('product:variant-change', (e) => {
        const vid = e.detail && e.detail.variant && e.detail.variant.id;
        if (vid) updateVariantLabel(vid);
      });

      window.addEventListener('load', () => updateVariantLabel(getCurrentVariantId()), { once: true });
      window.setTimeout(() => updateVariantLabel(getCurrentVariantId()), 300);
    }

  })();
